import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=b16f1056&scoped=true"
var script = {}
import style0 from "./layout.vue?vue&type=style&index=0&id=b16f1056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16f1056",
  null
  
)

export default component.exports